
import { Box } from "@mui/material";
import { useState } from "react";
import ResponsiveTabs from "../../components/OB/Tabbar";
import BireyselUyelik from "./bireysel-uyelik";
import KurumsalUyelik from "./kurumsla-uyelik";
import UyelikDogrulamaPopup from "../../components/OB/popups/uyelik-dogrulama-popup";
import  SessionStorageService  from "../../services/StorageService";


const KayitOl = () => {
  const [value, setValue] = useState(0);
  const user=SessionStorageService.getUserInfo()

  const [smsControlled, setSmsControlled] = useState(user != null);
  const [tcKimlikNo, setTcKimlikNo] = useState(user ? user.tcKimlikNo : "");
  const [cepTelefonu, setCepTelefonu] = useState("");
  const [vergiNo, setVergiNo] = useState("");
  const [uyelikTipi, setUyelikTipi] = useState(0); // 1: Bireysel, 2: Kurumsal
  const [secilenSicilNo, setSecilenSicilNo] = useState<number | null>(null);

  const handleChange = (event:any, newValue:any) => {
    setValue(newValue);
  };

  // Doğrulama popup'ı
  if (!smsControlled) {
    return (
      <UyelikDogrulamaPopup
        smsControlledSet={setSmsControlled}
        cepTelefonuSet={setCepTelefonu}
        tcKimlikNoSet={setTcKimlikNo}
        vergiNoSet={setVergiNo}
        uyelikTipiSet={setUyelikTipi}
        secilenSicilNoSet={setSecilenSicilNo}
      />
    );
  }

  // Giriş yapmış kullanıcı: tab yapısıyla her iki formu göster
  if (user != null) {
    return (
      <div className="mt-3">
        <ResponsiveTabs
          items={[
            { title: "Bireysel Üyelik", onClick: () => console.log("Tab 1 clicked") },
            { title: "Kurumsal Üyelik", onClick: () => console.log("Tab 2 clicked") },
            
          ]}
          value={value}
          onChange={handleChange}
          spreadWidth={false}
        />
        <Box className="pt-2">
          {value === 0 && <BireyselUyelik cepTelefonu={cepTelefonu} tcNo={tcKimlikNo}/>}
          {value === 1 && <KurumsalUyelik cepTelefonu={cepTelefonu} tcNo={tcKimlikNo}/>}
        </Box>
      </div>
    );
  }

  // Doğrulamayı geçen kullanıcı: seçilen üyelik tipine göre direkt form göster
  return (
    <div className="mt-3">
      <Box className="pt-2">
        {uyelikTipi === 1 && (
          <BireyselUyelik cepTelefonu={cepTelefonu} tcNo={tcKimlikNo} />
        )}
        {uyelikTipi === 2 && (
          <KurumsalUyelik cepTelefonu={cepTelefonu} tcNo={tcKimlikNo} vergiNo={vergiNo} sicilKodu={secilenSicilNo} />
        )}
      </Box>
    </div>
  );
};

export default KayitOl;